import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api.service';
import { ExcelService } from '../services/excel.service';
@Component({
  selector: 'app-downloads',
  templateUrl: './downloads.component.html',
  styleUrls: ['./downloads.component.scss']
})
export class DownloadsComponent implements OnInit {

  constructor(private excelservice: ExcelService, private api: ApiService) { }
  changeOverusage!: any[];
  timeBlocks!: any[];
  factoryList: any[] = [];
  selectedFactoryId: string | null = null;
  ngOnInit(): void {
    this.api.getFactoryList().subscribe(data => {
      this.factoryList = data;
    });
  }
  onselectFactory() {
    this.api.getChangeOverUsage(this.selectedFactoryId).subscribe(data => {
      this.changeOverusage = data;
    });
    this.api.getTimeBlocks(this.selectedFactoryId).subscribe(data => {
      this.timeBlocks = data;
    })
  }
  download(option: number) {
    if (!this.selectedFactoryId) { return; }
    switch (option) {
      case 1:
        if (this.changeOverusage.length) { this.excelservice.exportToExcel(this.changeOverusage, 'change-over-usage') };
        break;
      case 2:
        if (this.timeBlocks.length) {
          let keys = Object.keys(this.timeBlocks[0]);
          let flatenedTimebloksData: any[] = [];
          this.timeBlocks.map((item: any) => {
            let tempObj: any = {};
            keys.map((key: string) => {
              tempObj[key] = key === 'type' ? item[key].value : item[key];
            })
            flatenedTimebloksData.push(tempObj);
          })
          this.excelservice.exportToExcel(flatenedTimebloksData, 'timebloks');
        }
        break;
    }

  }
}
